// React-Screen COnlyPayMode ("Anzahlung") - Strangler Phase 5, Klasse A.
// Runbook: tools/REACT-STRANGLER.md.
// Ersetzt die ESM-Huelle onlypaymode.js (aus
// lib/scripts/pos/components/CMP_COnlyPayMode.js).
// Legacy-DOM-Fixture: tests/react-fixtures/COnlyPayMode.html, gezogen aus
// tests/visual-baseline/21-overlay-anzahlung.html.
//
// Statischer Screen ohne Zustand: die Texte stehen ab dem Zeichnen fest
// (kein reValue), deshalb darf die Caption Klasse und Wert koppeln - anders
// als bei CPriceInputMode (s. Muster-Abschnitt im Runbook).
// Geoeffnet aus CMainPOS.paydown ("Anzahlung", verlangt offenen Bon und
// einen Betrag kleiner als die offene Summe), abgebaut ueber den
// Abbrechen-Button oder von CMainPOS.payment, sobald eine Zahlungsart
// gewaehlt wird.
import { defineReactScreen } from '../bridge.js';
import { CPushButton } from '../../components/pushbutton.js';

// Legacy-CCaption: innerHTML = value UND class = "CCaption <addclass> <value>".
function Caption({ bridge, path, addclass, value, style }) {
  const cls = 'CCaption' + (addclass ? ' ' + addclass : '') + ' ' + value;
  return <p {...bridge.el(path, 'CCaption')} className={cls} style={style} dangerouslySetInnerHTML={{ __html: value }} />;
}

// Container, die der Anzahlungsmodus sperrt - Reihenfolge wie im Legacy-Code.
// Die Zahlungs-Panels bleiben bedienbar, das ist der Sinn des Screens.
const BLOCKED = ['bonfnc', 'leftPad', 'bonedit', 'prodSelect', 'numPad'];

// Legacy-prepare()/restoreMainPos() sperren bzw. entsperren identisch. Der
// Index-Ausdruck ueber payment.buttons.length trifft die letzten beiden
// Knoepfe von payment2 (Personalkauf/Lieferschein) - unveraendert
// uebernommen, inklusive des Waechters, der auf 5- prueft und 4- mitzieht.
function setMainEnabled(Main, enabled) {
  for (const name of BLOCKED) Main.components[name].setEnabled(enabled);

  if (Main.components.payment2.children[5 - Main.components.payment.buttons.length]) {
    Main.components.payment2.children[4 - Main.components.payment.buttons.length].setEnabled(enabled);
    Main.components.payment2.children[5 - Main.components.payment.buttons.length].setEnabled(enabled);
  }
}

function OnlyPayModeScreen({ bridge }) {
  const t = bridge.t;
  // Legacy: okButton bleibt ein normaler CPushButton ohne Handler (nur die
  // Standard-Listener fuer den Dispatcher-Unlock), ist aber unsichtbar.
  const okButton = bridge.widget('7', 'CPushButton', {
    events: { onMousedown: true, onMouseout: true, onMouseup: true },
    proto: CPushButton.prototype,
  });
  // Legacy: backButton.properties.events.onMousedown = this.cancel;
  //         cancel(component, parameters) -> POS.getComponentById(parameters[0]).doCancel(...)
  const backButton = bridge.widget('8', 'CPushButton', {
    events: { onMousedown: () => bridge.doCancel(bridge), onMouseout: true, onMouseup: true },
    attributes: { onMousedown_parameter_0: bridge.id },
    proto: CPushButton.prototype,
  });

  return (
    <>
      {/* wholeOverlay */}
      <div {...bridge.el('0', 'CFrame')} className="CFrame wholeoverlay" style={{ position: 'absolute' }}></div>
      {/* overlay */}
      <div {...bridge.el('1', 'CFrame')} className="CFrame overlay" style={{ position: 'absolute' }}></div>
      {/* titleBack */}
      <div {...bridge.el('2', 'CFrame')} className="CFrame titleback" style={{ position: 'absolute' }}></div>
      {/* titleText */}
      <Caption bridge={bridge} path="3" addclass="titletext" value={t('LABELS', 'PAYDOWN_MODE')} />
      {/* contentText - fontSize setzte Legacy-prepare direkt auf die Property */}
      <Caption bridge={bridge} path="4" addclass="contenttext" value={t('LABELS', 'PAYDOWN_MODE_TEXT')} style={{ fontSize: '15px' }} />
      {/* priceText */}
      <Caption bridge={bridge} path="5" addclass="pricetext" value=" " />
      {/* unitsText */}
      <Caption bridge={bridge} path="6" addclass="unitstext" value=" " />
      {/* okButton */}
      <div {...okButton} className="CPushButton okbutton" style={{ visibility: 'hidden' }}>
        <Caption bridge={bridge} path="7:0" addclass="" value=" " />
      </div>
      {/* backButton */}
      <div {...backButton} className="CPushButton backbutton">
        <p {...bridge.el('8:0', 'CCaption')} className="CCaption undefined"></p>
      </div>
    </>
  );
}

export const COnlyPayMode = defineReactScreen({
  className: 'COnlyPayMode',
  addclass: 'COnlyPayMode CashWindow',
  htmlType: 'div',
  Screen: OnlyPayModeScreen,
  // Legacy-prepare() ohne den XML-/Event-Teil. Die Sichtbarkeit setzt es auf
  // die Wurzel-Properties - prepare() laeuft vor create(), das Wurzelelement
  // bekommt das inline-style also wie bisher vom Builder.
  prepare(bridge) {
    // Der Aufrufer (CMainPOS.paydown) setzt .Main vor draw(); Legacy holt es
    // hier trotzdem noch einmal aus der Session - dasselbe Objekt.
    bridge.Main = POS.sessions.getSessionComponent();

    setMainEnabled(bridge.Main, false);

    bridge.properties.styles.visibility = 'visible';
  },
  methods: {
    restoreMainPos(bridge) {
      setMainEnabled(bridge.Main, true);
    },
    // Aufrufer: Abbrechen-Button und CMainPOS.payment (dort als
    // me.cmpOnlyPay.doCancel(me.cmpOnlyPay) - das Argument ist immer der
    // Screen selbst, die Bridge benutzt deshalb sich selbst).
    doCancel(bridge) {
      bridge.restoreMainPos();
      bridge.removeMe();

      log.add(4, 'Info', 'End paydown mode', '');
    },
  },
});
